import { useState } from "react";
import { Dialog, DialogContent, Button, Box, Typography } from "@mui/material";
import { AutoAwesome, EmojiEvents, AttachMoney } from "@mui/icons-material";
import { ClaimSpinReward } from "../../redux/slices/gift";
import { useDispatch } from "react-redux";

export default function SpinWheelSuccess({
  showResult,
  selectedPrize,
  resetWheel,
  onClose,
  wheelReward,
}) {
  const [submitting, setSubmitting] = useState(false);
  const dispatch = useDispatch();

  const handleClaim = async () => {
    setSubmitting(true);
    const success = await dispatch(
      ClaimSpinReward({
        token: wheelReward.token,
        amount: selectedPrize.value,
      })
    );
    if (success) {
      onClose();
      resetWheel();
    }
    setSubmitting(false);
  };
  return (
    <Dialog
      open={showResult && !!selectedPrize}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "24px",
          backgroundColor: "#3b0709",
          boxShadow:
            "0 20px 60px rgba(0,0,0,0.7), inset 0 1px 0 rgba(255,255,255,0.1)",
          border: "2px solid rgba(255,156,25,0.3)",
          overflow: "hidden",
          position: "relative",
        },
      }}
    >
      <DialogContent sx={{ p: 6, textAlign: "center", position: "relative" }}>
        {/* Floating confetti icons */}
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            overflow: "hidden",
            pointerEvents: "none",
          }}
        >
          {[...Array(20)].map((_, i) => (
            <Box
              key={i}
              sx={{
                position: "absolute",
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animation: "float 3s ease-in-out infinite",
                animationDelay: `${Math.random() * 2}s`,
              }}
            >
              <AutoAwesome
                sx={{
                  color: i % 2 === 0 ? "#ff9c19" : "#e2008a",
                  opacity: 0.3,
                  fontSize: 16,
                }}
              />
            </Box>
          ))}
        </Box>

        {/* Main Content */}
        <Box sx={{ position: "relative", zIndex: 10 }}>
          <Box sx={{ mb: 4 }}>
            <EmojiEvents
              sx={{
                color: "#ff9c19",
                fontSize: 64,
                animation: "bounce 1.5s infinite",
                filter: "drop-shadow(0 0 20px rgba(255,156,25,0.8))",
              }}
            />
          </Box>

          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#fff",
              textShadow: "0 0 20px rgba(255,156,25,0.5)",
              mb: 1.5,
            }}
          >
            🎉 Congratulations! 🎉
          </Typography>

          <Typography sx={{ color: "rgba(255,255,255,0.8)", mb: 4 }}>
            You won an amazing prize!
          </Typography>

          <Box
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 2,
              px: 6,
              py: 3,
              borderRadius: "16px",
              fontSize: "3rem",
              fontWeight: "bold",
              background: "linear-gradient(135deg, #280203 0%, #3b0709 100%)",
              color: "#ffd700",
              boxShadow:
                "0 0 40px rgba(255,215,0,0.4), inset 0 2px 0 rgba(255,255,255,0.1)",
              border: "3px solid rgba(255,215,0,0.3)",
              textShadow:
                "0 0 30px rgba(255,215,0,0.8), 0 4px 8px rgba(0,0,0,0.8)",
              mb: 4,
            }}
          >
            <AttachMoney sx={{ fontSize: 56 }} />
            {selectedPrize?.value}
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            <Button
              sx={{
                px: 5,
                py: 1.5,
                fontWeight: "bold",
                fontSize: "1.1rem",
                color: "#fff",
                borderRadius: "12px",
                backgroundColor: "#e2008a",
                boxShadow: "0 6px 20px rgba(226,0,138,0.5)",
                border: "2px solid rgba(255,51,166,0.3)",
                transition: "all 0.2s ease",
                "&:hover": {
                  backgroundColor: "#ff33a6",
                  transform: "translateY(-2px) scale(1.05)",
                },
              }}
              onClick={handleClaim}
              disabled={submitting}
              loading={submitting}
            >
              💎 Claim Prize
            </Button>
          </Box>
        </Box>
      </DialogContent>

      {/* Custom animations */}
      <style>
        {`
          @keyframes float {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-10px); }
          }
          @keyframes bounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
          }
        `}
      </style>
    </Dialog>
  );
}
